// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react: true*/
import React, {useContext} from 'react';
import {useTranslation} from 'react-i18next';
import cn from 'classnames';
import {Settings_context} from '../../settings_ctx';
import {Cards, i_card, i_cls_obj} from '../cards';
import {On_scroll_animation} from '../../shared/on_scroll_animation';
import styles from './hola_pros.module.less';

type i_hola_pros = {
  title_suffix?: string;
  cards?: i_card[];
  cls?: i_cls_obj;
}
export const Hola_pros = (props:i_hola_pros)=>{
    const {theme} = useContext(Settings_context);
    const {t} = useTranslation() as any;
    const cards: i_card[] = props?.cards||
      ['connection', 'devices', 'support'].map(id=>({
        id,
        title: t(`hp.hola_pros.${id}.title`),
        text: t(`hp.hola_pros.${id}.text`),
        img: <On_scroll_animation key={id}
          src={`animation/hola_pros_${id}.json`} size={[335, 206]}
          animation={[{frames: {from: 50, to: 75}, direction: 1, loop: false}]}
          cls={styles.card_anim} scroll_to_pos={0.05}/>,
    }));
    const cls = {
        card: styles.card,
        title: cn(theme.u2, styles.card_title),
        text: cn(theme.p2, theme.reg),
    };
    return <div className={cn(theme.container, theme.block, styles.hola_pros)}>
      <h2>You'll love Hola{props.title_suffix ? props.title_suffix : '!'}</h2>
      <Cards cards={cards} cls={props?.cls||cls}/>
    </div>;
};
